import axiosInstance from "./axiosInstance";

const saleAgentService = {
  getAccess: async () => {
    const res = await axiosInstance.get("/admin/sale-agent/access");
    return res.data;
  },

  listLeads: async (params = {}) => {
    const res = await axiosInstance.get("/admin/sale-agent/leads", { params });
    return res.data;
  },

  lookupPhone: async (phone, agent_id) => {
    const res = await axiosInstance.get("/admin/sale-agent/leads/lookup-phone", {
      params: { phone, ...(agent_id ? { agent_id } : {}) },
    });
    return res.data;
  },

  createLead: async (payload) => {
    const res = await axiosInstance.post("/admin/sale-agent/leads", payload);
    return res.data;
  },

  updateLead: async (id, payload) => {
    const res = await axiosInstance.put(`/admin/sale-agent/leads/${id}`, payload);
    return res.data;
  },

  reassignLead: async (id, agent_id) => {
    const res = await axiosInstance.put(`/admin/sale-agent/leads/${id}/reassign`, { agent_id });
    return res.data;
  },

  unassignLead: async (id) => {
    const res = await axiosInstance.post(`/admin/sale-agent/leads/${id}/unassign`);
    return res.data;
  },

  deleteLead: async (id) => {
    const res = await axiosInstance.delete(`/admin/sale-agent/leads/${id}`);
    return res.data;
  },

  contactLead: async (id, payload) => {
    const res = await axiosInstance.post(`/admin/sale-agent/leads/${id}/contact`, payload);
    return res.data;
  },

  logCall: async (id, payload) => {
    const res = await axiosInstance.post(`/admin/sale-agent/leads/${id}/calls`, payload);
    return res.data;
  },

  getCallHistory: async (id) => {
    const res = await axiosInstance.get(`/admin/sale-agent/leads/${id}/calls`);
    return res.data;
  },

  sendChat: async (id, message) => {
    const res = await axiosInstance.post(`/admin/sale-agent/leads/${id}/chat`, { message });
    return res.data;
  },

  importLeads: async (leads) => {
    const res = await axiosInstance.post("/admin/sale-agent/leads/import", { leads });
    return res.data;
  },
};

export default saleAgentService;
